import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { TextEditorService } from './text-editor.service';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FiTextEditorComponent } from './fi-text-editor/fi-text-editor.component';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiTextEditorPanelComponent } from './fi-text-editor-panel/fi-text-editor-panel.component';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatMenuModule } from '@angular/material/menu';
import { TextEditorInsertEmbedVideoService } from '@fi-shared/fi-text-editor/fi-text-editor-insert-embed-video/text-editor-insert-embed-video.service';
import { TextEditorInsertEmbedVideoDialogComponent } from '@fi-shared/fi-text-editor/fi-text-editor-insert-embed-video/text-editor-insert-embed-video-dialog.component';
import { AdvancedTextHandlerService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/advanced-text-handler.service';
import { TextEditorSelectionElementBuilderService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-selection-element-builder.service';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { TextEditorInsertLinkService } from '@fi-shared/fi-text-editor/fi-text-editor-insert-link/text-editor-insert-link.service';
import { TextEditorInsertLinkDialogComponent } from '@fi-shared/fi-text-editor/fi-text-editor-insert-link/text-editor-insert-link-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { LinkToModule } from '@fi-shared/link-to/link-to.module';
import { FiTextEditorTagUsers2Component } from './fi-text-editor-tag-users2/fi-text-editor-tag-users2.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { FiGiphyModule } from '@fi-shared/fi-giphy/fi-giphy.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { TextEditorInsertLinkFoldableComponent } from '@fi-shared/fi-text-editor/fi-text-editor-insert-link/text-editor-insert-link-foldable/text-editor-insert-link-foldable.component';
import { FiMenuFoldableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-multi-select-item-search.module';
import { FiContactsModule } from '@fi-shared/fi-contacts/fi-contacts.module';
import { TextEditorTagUsersService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-tag-users.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        FiLoadingModule,
        FiProfileIconModule,
        FiVimeoModule,
        MatProgressBarModule,
        FiContenteditableModule,
        MatButtonModule,
        MatIconModule,
        FiAttachmentsModule,
        MatMenuModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        LinkToModule,
        MatAutocompleteModule,
        FiInsertMediaModule,
        FiGiphyModule,
        SelectSearchModule,
        FiMenuFoldableMultiSelectItemSearchModule,
        FiContactsModule,
    ],
    declarations: [
        FiTextEditorComponent,
        FiTextEditorPanelComponent,
        TextEditorInsertEmbedVideoDialogComponent,
        TextEditorInsertLinkDialogComponent,
        TextEditorInsertLinkFoldableComponent,
        FiTextEditorTagUsers2Component,
    ],
    exports: [FiTextEditorComponent, FiTextEditorTagUsers2Component],
    providers: [
        TextEditorService,
        TextEditorInsertEmbedVideoService,
        TextEditorInsertLinkService,
        TextEditorTagUsersService,
        AdvancedTextHandlerService,
        TextEditorSelectionElementBuilderService,
        TextEditorHistoryService,
    ],
})
export class FiTextEditorSharedModule {}
